/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClaimPayloadDto
 */
export interface UpdateClaimPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    insuredId?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClaimPayloadDto
     */
    dateOfLoss?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClaimPayloadDto
     */
    dateReported?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    claimsHandler?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    causeOfLoss?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    catCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    subClass?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    lossLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    status?: UpdateClaimPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    lossDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPayloadDto
     */
    lineOfBusiness?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClaimPayloadDto
     */
    fileIds?: Array<string>;
}


/**
 * @export
 */
export const UpdateClaimPayloadDtoStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type UpdateClaimPayloadDtoStatusEnum = typeof UpdateClaimPayloadDtoStatusEnum[keyof typeof UpdateClaimPayloadDtoStatusEnum];


/**
 * Check if a given object implements the UpdateClaimPayloadDto interface.
 */
export function instanceOfUpdateClaimPayloadDto(value: object): value is UpdateClaimPayloadDto {
    return true;
}

export function UpdateClaimPayloadDtoFromJSON(json: any): UpdateClaimPayloadDto {
    return UpdateClaimPayloadDtoFromJSONTyped(json, false);
}

export function UpdateClaimPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredId': json['insuredId'] == null ? undefined : json['insuredId'],
        'dateOfLoss': json['dateOfLoss'] == null ? undefined : (new Date(json['dateOfLoss'])),
        'dateReported': json['dateReported'] == null ? undefined : (new Date(json['dateReported'])),
        'claimsHandler': json['claimsHandler'] == null ? undefined : json['claimsHandler'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'causeOfLoss': json['causeOfLoss'] == null ? undefined : json['causeOfLoss'],
        'catCode': json['catCode'] == null ? undefined : json['catCode'],
        'subClass': json['subClass'] == null ? undefined : json['subClass'],
        'lossLocation': json['lossLocation'] == null ? undefined : json['lossLocation'],
        'status': json['status'] == null ? undefined : json['status'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lossDescription': json['lossDescription'] == null ? undefined : json['lossDescription'],
        'lineOfBusiness': json['lineOfBusiness'] == null ? undefined : json['lineOfBusiness'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function UpdateClaimPayloadDtoToJSON(json: any): UpdateClaimPayloadDto {
    return UpdateClaimPayloadDtoToJSONTyped(json, false);
}

export function UpdateClaimPayloadDtoToJSONTyped(value?: UpdateClaimPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredId': value['insuredId'],
        'dateOfLoss': value['dateOfLoss'] == null ? undefined : ((value['dateOfLoss']).toISOString()),
        'dateReported': value['dateReported'] == null ? undefined : ((value['dateReported']).toISOString()),
        'claimsHandler': value['claimsHandler'],
        'currency': value['currency'],
        'causeOfLoss': value['causeOfLoss'],
        'catCode': value['catCode'],
        'subClass': value['subClass'],
        'lossLocation': value['lossLocation'],
        'status': value['status'],
        'city': value['city'],
        'country': value['country'],
        'lossDescription': value['lossDescription'],
        'lineOfBusiness': value['lineOfBusiness'],
        'fileIds': value['fileIds'],
    };
}

